<template>
	<div :class="containerClass" @click="onWrapperClick">
        <Toast />
        <AppTopBar @menu-toggle="onMenuToggle" v-show="getUsuarioLogueado"/>
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="getMenu" @menuitem-click="onMenuItemClick" v-show="getUsuarioLogueado"/>
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
            <AppFooter v-show="getUsuarioLogueado"/>
        </div>

		<!-- <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" v-show="getUsuarioLogueado"/> -->
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
// import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import {mapGetters,mapActions} from 'vuex';

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menuSoporteTecJefeCoordinadores: [
                {
					label: 'Soporte técnico', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Unidades', icon: 'pi pi-fw pi-desktop', to: '/unidades'},
                        {label: 'Universo', icon: 'pi pi-fw pi-globe', to: '/universo'},
                        {label: 'Equipos de cómputo', icon: 'pi pi-desktop', to: '/equiposcomputo'},
                        {label: 'Captura rápida', icon: 'pi pi-bolt', to: '/capturarapida'},
                        {label: 'Estatus', icon: 'pi pi-fw pi-info-circle', to: '/status'}, 
                        {label: 'Referencias', icon: 'pi pi-fw pi-comment', to: '/referencias'},
                        {label: 'Servidores', icon: 'pi pi-fw pi-server', to: '/monitoreoSitios/servidores'},
                        {label: 'Mantenimientos', icon: 'pi pi-calendar-plus', to: '/mantenimientos'}                                           
					]
				}

            ],
            menuSoporteTec: [
                {
					label: 'Soporte técnico', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Unidades', icon: 'pi pi-fw pi-desktop', to: '/unidades'},
                        {label: 'Universo', icon: 'pi pi-fw pi-globe', to: '/universo'},
                        {label: 'Equipos de cómputo', icon: 'pi pi-desktop', to: '/equiposcomputo'},
                        {label: 'Captura rápida', icon: 'pi pi-bolt', to: '/capturarapida'},
                        {label: 'Estatus', icon: 'pi pi-fw pi-info-circle', to: '/status'},                                         
                        {label: 'Referencias', icon: 'pi pi-fw pi-comment', to: '/referencias'},
                        {label: 'Servidores', icon: 'pi pi-fw pi-server', to: '/monitoreoSitios/servidores'},
                        {label: 'Mantenimientos', icon: 'pi pi-calendar-plus', to: '/mantenimientos'}                        
					]
				}

            ],
            menuSuperAdmin : [ //Menu general
                {
                    label: 'Home',
                    items: [{
                        label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'
                    }]
                },    
                                {
                    label: 'Telefonia', icon: 'pi pi-fw pi-phone',
                    items: [
                        {label: 'Directorio de unidades', icon: 'pi pi-sitemap', to: '/directoriounidad'},
                        {label: 'Reporte de líneas', icon: 'pi pi-chart-line', to: '/reportes_lineas'},
                        {label: 'Facturación', icon: 'pi pi-fw pi-dollar', to: '/facturacion'}
                    ]
                },
                {
                    label: 'Redes', icon: 'pi pi-fw pi-wifi',
                    items: [
                        {label: 'Inventario', icon: 'pi pi-fw pi-sitemap', to: '/equipos'},
                        {label: 'Estatus', icon: 'pi pi-fw pi-info-circle', to: '/status'},
                        {label: 'Documentación', icon: 'pi pi-fw pi-file', to: '/documentos'},
                        {label: 'Referencias', icon: 'pi pi-fw pi-comment', to: '/referencias'},
                    ]
                },                 
                {
					label: 'Monitoreo Equipos SIMF', icon: 'pi pi-fw pi-desktop',
					items: [
                        {label: 'Servidores', icon: 'pi pi-fw pi-server', to: '/monitoreoSitios/servidores'},
					]
				},             
                {
					label: 'Configuración', icon: 'pi pi-fw pi-sitemap',
					items: [                        
                        {label: 'Productos', icon: 'pi pi-tag', to: '/productos'},
                        {label: 'Entradas productos', icon: 'pi pi-tags', to: '/entradasproductos'},    
                        {label: 'Estados', icon: 'pi pi-tags', to: '/estados'},    
                        {label: 'Delegaciones', icon: 'pi pi-tags', to: '/delegaciones'},    
                        {label: 'Importacion CAT CONV', icon: 'pi pi-tags', to: '/catconv'},    
                        {label: 'Usuarios - Ubicaciones', icon: 'pi pi-tags', to: '/usuariosubicaciones'},  
                        {label: 'Tipos de servicio', icon: 'pi pi-fw pi-book', to: '/tipos_servicios'},
                        {label: 'Tipos de dispositivos', icon: 'pi pi-fw pi-list', to: '/tipos_dispositivos'},
                        {label: 'Tipos de medios', icon: 'pi pi-fw pi-shield', to: '/tipos_medios'},
                        {label: 'Tipos de lineas', icon: 'pi pi-fw pi-sliders-h', to: '/tipos_lineas'},
                        {label: 'Tipos de estatus', icon: 'pi pi-fw pi-check-circle', to: '/tipos_estatus'},
						{label: 'Modalidades', icon: 'pi pi-fw pi-wrench', to: '/tipos_modalidades'},
						{label: 'Tipos de fallos', icon: 'pi pi-fw pi-wrench', to: '/tipos_fallos'},
					]
				},
                {
					label: 'Soporte técnico', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Empleados', icon: 'pi pi-fw pi-user', to: '/empleados'},
                        {label: 'Unidades', icon: 'pi pi-fw pi-desktop', to: '/unidades'},
                        {label: 'Equipos de cómputo', icon: 'pi pi-desktop', to: '/equiposcomputo'},
                        {label: 'Captura rápida', icon: 'pi pi-bolt', to: '/capturarapida'},
                        {label: 'Salidas CBM2', icon: 'pi pi-shopping-cart', to: '/salidascbm2'},                        
                        {label: 'Mantenimientos', icon: 'pi pi-calendar-plus', to: '/mantenimientos'},
                        {label: 'Garantías', icon: 'pi pi-inbox', to: '/garantias'},
                        {label: 'Universo', icon: 'pi pi-fw pi-globe', to: '/universo'},
                        {label: 'Existencias', icon: 'pi pi-tag', to: '/existencias'}                       
					]
				},
                {
					label: 'Reportes REMEDY', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Carga archivos Remedy', icon: 'pi pi-desktop', to: '/reportesRemedy/cargaarchivosremedy'},                                                                                  
					]
				},
            ],
            menuAdminTelecom : [
                {
                    label: 'Home',
                    items: [{
                        label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'
                    }]
                },
				{
					label: 'TELECOM', icon: 'pi pi-fw pi-sitemap',
					items: [
						{label: 'Equipos', icon: 'pi pi-fw pi-sitemap', to: '/equipos'},
                        {label: 'Estatus', icon: 'pi pi-fw pi-info-circle', to: '/status'},
                        {label: 'Reportes TELMEX', icon: 'pi pi-fw pi-phone', to: '/reportestelmex'},
                        {label: 'Documentación', icon: 'pi pi-fw pi-file', to: '/documentos'},
                        {label: 'Referencias', icon: 'pi pi-fw pi-comment', to: '/referencias'},
					]
				},
                {
					label: 'CATÁLOGOS', icon: 'pi pi-fw pi-sitemap',
					items: [
						{label: 'Servicios', icon: 'pi pi-fw pi-list', to: '/tipos_servicios'},
						{label: 'Dispositivos', icon: 'pi pi-fw pi-book', to: '/tipos_dispositivos'},
						{label: 'Modalidades', icon: 'pi pi-fw pi-wrench', to: '/tipos_modalidades'},
					]
				}, 
                {
					label: 'Monitoreo Equipos SIMF', icon: 'pi pi-fw pi-desktop',
					items: [
                        {label: 'Servidores', icon: 'pi pi-fw pi-server', to: '/monitoreoSitios/servidores'},
					]
				},   
            ],
            menuWalter : [
                {
                    label: 'Home',
                    items: [{
                        label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'
                    }]
                },
				{
					label: 'TELECOM', icon: 'pi pi-fw pi-sitemap',
					items: [
						{label: 'Equipos', icon: 'pi pi-fw pi-sitemap', to: '/equipos'},
                        {label: 'Estatus', icon: 'pi pi-fw pi-info-circle', to: '/status'},                        
                        {label: 'Referencias', icon: 'pi pi-fw pi-comment', to: '/referencias'},
					]
				},
                {
					label: 'CATÁLOGOS', icon: 'pi pi-fw pi-sitemap',
					items: [
						{label: 'Servicios', icon: 'pi pi-fw pi-list', to: '/tipos_servicios'},
						{label: 'Dispositivos', icon: 'pi pi-fw pi-book', to: '/tipos_dispositivos'},
						{label: 'Modalidades', icon: 'pi pi-fw pi-wrench', to: '/tipos_modalidades'},
					]
				},                     
                {
					label: 'Salidas', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Salidas CBM2', icon: 'pi pi-shopping-cart', to: '/salidascbm2'},                        
					]
				},
                {
					label: 'Configuración', icon: 'pi pi-fw pi-sitemap',
					items: [                        
                        {label: 'Productos', icon: 'pi pi-database', to: '/productos'},
                        {label: 'Entradas productos', icon: 'pi pi-tags', to: '/entradasproductos'},                            
					]
				},
            ],
            
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        ...mapActions([
            "setLoading",
        ]),       
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        ...mapGetters([
            "getUsuarioLogueado",
            "getLoading",
        ]),
        getMenu(){
            //console.log(this.getUsuarioLogueado);
            if(this.getUsuarioLogueado && this.getUsuarioLogueado.Usuario_sistema){                
                //SE CREA EL MENU DE ACUERDO A SU ROL               
                if(this.getUsuarioLogueado.Usuario_sistema.Id_sistema == 4 && this.getUsuarioLogueado.Usuario_sistema.Id_rol == 1)
                    return this.menuSuperAdmin;
                else if(this.getUsuarioLogueado.Usuario_sistema.Id_sistema == 4 && this.getUsuarioLogueado.Usuario_sistema.Id_rol == 2)                
                    return this.menuAdminTelecom;                
                else if(this.getUsuarioLogueado.Usuario_sistema.Id_sistema == 4 && this.getUsuarioLogueado.Usuario_sistema.Id_rol == 8)
                    return this.menuWalter;
                else if(this.getUsuarioLogueado.Usuario_sistema.Id_sistema == 4 && this.getUsuarioLogueado.Usuario_sistema.Id_rol == 3)                    
                    return this.menuSoporteTec;    
                else if(this.getUsuarioLogueado.Usuario_sistema.Id_sistema == 4 && this.getUsuarioLogueado.Usuario_sistema.Id_rol == 9)                    
                    return this.menuSoporteTecJefeCoordinadores;              
                else
                    return [];
            }
            else
            {
                return [];
            }
        },
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false,
                'fondologin': !this.getUsuarioLogueado

            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        // 'AppConfig': AppConfig,
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
